import { atom } from "recoil";

export const previewModalImgState = atom({
  default:
    "https://cdna.katch.gg/verified/4ce041ce-a7c4-4af0-879a-6bb0476c15a8_The_Star_Theatre-_Morrissey.svg",
  key: "previewModalImgState",
});
